const PrivacyPage = () => {
  return (
    <div data-testid="privacy-page">
      {/* Hero Section */}
      <section className="bg-[#f5f6fa] py-16 md:py-24">
        <div className="section-container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="heading-1 text-[#1a1f36] mb-6">
              Privacy Policy
            </h1>
            <p className="body-large">
              Informativa sul trattamento dei dati personali
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="section-container">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <div className="bg-white rounded-2xl border border-[#e2e4ed] p-8 md:p-12">
              <p className="text-[#4a5068] mb-8">
                La presente informativa è resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) 
                e descrive le modalità di gestione del sito web in riferimento al trattamento dei dati 
                personali degli utenti che lo consultano.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">1. Titolare del trattamento</h2>
              <p className="text-[#4a5068] mb-4">Il Titolare del trattamento è:</p>
              <div className="bg-[#f5f6fa] p-6 rounded-xl mb-6">
                <p className="font-semibold text-[#1a1f36]">4D Sistemi Informatici SRL</p>
                <p className="text-[#4a5068]">Sede legale: Via Kennedy 84, 27058, Voghera, PV</p>
                <p className="text-[#4a5068]">P.IVA: 02115810182</p>
                <p className="text-[#4a5068]">Email: info@4dsistemi.it</p>
              </div>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">2. Tipologie di dati raccolti</h2>
              <p className="text-[#4a5068] mb-4">Durante la navigazione sul sito possono essere raccolti i seguenti dati:</p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-6">
                <li>dati di navigazione (indirizzi IP, informazioni sul browser, log di sistema)</li>
                <li>dati forniti volontariamente dall'utente tramite moduli di contatto</li>
                <li>dati eventualmente inviati tramite email</li>
                <li>dati raccolti tramite cookie o strumenti di analisi</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">3. Finalità del trattamento</h2>
              <p className="text-[#4a5068] mb-4">I dati personali vengono trattati per le seguenti finalità:</p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-6">
                <li>rispondere alle richieste inviate tramite il modulo di contatto</li>
                <li>fornire informazioni sui servizi offerti</li>
                <li>gestire richieste di collaborazione o contatto</li>
                <li>migliorare l'esperienza di navigazione sul sito</li>
                <li>adempiere ad obblighi legali</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">4. Base giuridica del trattamento</h2>
              <p className="text-[#4a5068] mb-4">Il trattamento dei dati si basa su:</p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-6">
                <li>consenso dell'interessato</li>
                <li>esecuzione di misure precontrattuali</li>
                <li>legittimo interesse del titolare</li>
                <li>obblighi di legge</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">5. Modalità di trattamento</h2>
              <p className="text-[#4a5068] mb-6">
                Il trattamento dei dati avviene mediante strumenti informatici e telematici, adottando 
                misure di sicurezza adeguate per prevenire accessi non autorizzati, divulgazione, 
                modifica o distruzione dei dati.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">6. Conservazione dei dati</h2>
              <p className="text-[#4a5068] mb-6">
                I dati saranno conservati per il tempo strettamente necessario al raggiungimento 
                delle finalità sopra indicate e comunque nel rispetto degli obblighi di legge.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">7. Comunicazione dei dati</h2>
              <p className="text-[#4a5068] mb-4">
                I dati potranno essere comunicati a soggetti terzi che forniscono servizi necessari 
                al funzionamento del sito, tra cui:
              </p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-4">
                <li>provider hosting</li>
                <li>servizi di analisi statistica</li>
                <li>fornitori tecnici e informatici</li>
              </ul>
              <p className="text-[#4a5068] mb-6">I dati non saranno diffusi.</p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">8. Diritti dell'interessato</h2>
              <p className="text-[#4a5068] mb-4">
                L'utente può esercitare in qualsiasi momento i diritti previsti dagli articoli 15-22 
                del GDPR, tra cui:
              </p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-4">
                <li>accesso ai dati personali</li>
                <li>rettifica o cancellazione</li>
                <li>limitazione del trattamento</li>
                <li>opposizione al trattamento</li>
                <li>portabilità dei dati</li>
              </ul>
              <p className="text-[#4a5068] mb-6">
                Le richieste possono essere inviate all'indirizzo email: <strong>info@4dsistemi.it</strong>
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">9. Modifiche alla presente informativa</h2>
              <p className="text-[#4a5068]">
                Il titolare si riserva il diritto di aggiornare la presente informativa in qualsiasi momento. 
                Le modifiche saranno pubblicate su questa pagina.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
